export default {
  countryNames: (state) => state.countries.map(item => item.name)
}